import React, {useContext} from 'react';
import type {ConnectElementImportKeys} from '../../connect/ConnectJSInterface/ConnectElementList';
import {CONNECT_ELEMENT_IMPORTS} from '../../connect/ConnectJSInterface/ConnectElementList';
import type {
  ConnectElementSupplementalObjects,
  IConnectElementSupplementalObject,
} from '../../connect/ConnectElementSupplementalObjects';

export const SupplementalObjectContext = React.createContext<
  Partial<IConnectElementSupplementalObject>
>({});
SupplementalObjectContext.displayName = 'SupplementalObjectContext';

export type Props = {
  supplementalObjects: ConnectElementSupplementalObjects;
  component: ConnectElementImportKeys;
};

export const SupplementalObjectProvider: React.FC<Props> = ({
  children,
  supplementalObjects,
  component,
}) => {
  const componentConfig = CONNECT_ELEMENT_IMPORTS[component];
  const [currentSupplementalObject, setSupplementalObject] = React.useState<
    Partial<IConnectElementSupplementalObject>
  >(supplementalObjects.values);

  React.useEffect(() => {
    const observer = () => {
      setSupplementalObject(supplementalObjects.values);
    };
    supplementalObjects.registerObserver(observer);
    return () => {
      supplementalObjects.unregisterObserver(observer);
    };
  }, [supplementalObjects, componentConfig]);

  return (
    <SupplementalObjectContext.Provider value={currentSupplementalObject}>
      {children}
    </SupplementalObjectContext.Provider>
  );
};

export const useSupplementalObject = () =>
  useContext(SupplementalObjectContext);
